// src/Login.js
import { useState, useEffect } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

import { auth } from '../firebase'; // Asegúrate de importar 'db'
import '../Styles/Login.css';
import logo from '../Assets/hubLyseis.PNG';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/post-login');
    } catch (error) {
      alert('Error al iniciar sesión: ' + error.message);
    }
  };


  useEffect(() => {
    // Aplicar clase al body al montar el componente
    document.body.classList.add('login-body');

    // Limpiar al desmontar (para que no afecte otras páginas)
    return () => {
      document.body.classList.remove('login-body');
    };
  }, []);

  return (
    <div style={styles.container} className='body'>
      <img src={logo} alt="Logo" style={{width:'250px', height:'100px'}} />
      <input
        type="email"
        placeholder="Correo electrónico"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={styles.input}
      />
      <br />
      <input
        type="password"
        placeholder="Contraseña"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={styles.input}
      />
      <br />
      <button onClick={handleLogin} style={styles.button}>Iniciar sesión</button>
      <br />
    </div>
  );
}

const styles = {
  container: {
    padding: '20px',
    textAlign: 'center',
    backgroundColor: 'white',
    borderRadius: '8px',
    width: '80%',
    maxWidth: '350px',
    margin: '50px auto',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
  input: {
    padding: '10px',
    width: '95%',
    margin: '10px 0',
    borderRadius: '4px',
    border: '1px solid #A7C7E7', // Azul claro
    fontSize: '1em',
  },
  button: {
    marginTop: '10px',
    padding: '8px 20px',
    backgroundColor: '#1E3A8A', // Azul oscuro
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    width: '100%',
    fontSize: '1em',
  },
};

export default Login;
